import React, { useState } from 'react';
import { BestBoulderCard } from '../../constants/types';
import BestBoulderCardComponent from '../UI/BestBoulderCard';

interface BestBouldersListProps {
    boulders: BestBoulderCard[];
}

export const BestBouldersList: React.FC<BestBouldersListProps> = ({ boulders }) => {
    const [showMoreBoulders, setShowMoreBoulders] = useState(false);

    const displayedBoulders = showMoreBoulders ? boulders : boulders.slice(0, 4);

    return (
        <div className='flex flex-col gap-4 items-start w-full'>
            <div className='flex flex-row flex-wrap gap-4 w-full'>
                {displayedBoulders.map((boulder) => (
                    <BestBoulderCardComponent
                        key={boulder.id}
                        {...boulder}
                        hasDifficultySystem={true}
                    />
                ))}
            </div>
            {boulders.length > 4 && !showMoreBoulders && (
                <button
                    onClick={() => setShowMoreBoulders(true)}
                    className='px-4 py-2 bg-backoffice-50 text-backoffice-700 rounded-lg bold normal hover:bg-backoffice-100 transition-colors'
                >
                    Afficher la suite des blocs
                </button>
            )}
        </div>
    );
};

export default BestBouldersList;
